import banner from '../../media/Banner-Transparent-Home2.jpg';
import heroOGChefFemale from '../../media/home-chef3.png';
import heroOGChefMale from '../../media/home-chef2.png';
import heroVideo from '../../media/mk-logo-play-battle-earn.mp4';
import {HashLink as Link} from 'react-router-hash-link';
import config from '../../config';
import '../../css/mk-brand.css';

import {useState, useEffect} from "react";
import Countdown from 'react-countdown';

const onVideoClicked = () => {
    const video = document.getElementById("heroVideoElement");
    video.muted = false;
    video.play();
}
const video = <video id="heroVideoElement" src={heroVideo} autoPlay muted playsInline onClick={onVideoClicked} />;

function HeroPanel() {
  useEffect(() => {}, );
  return (
      <div id="hero-panel" className="container flex flex-col">
          { config.IS_MINT_ACTIVE ?
              <div className="flex justify-center mx-auto">
                  <Link to="/mint/" className="no-underline text-brand-text hover:text-brand-text">
                      <button className="z-30 bg-brand font-bold text-2xl text-brand-text rounded-lg p-4 w-48 hover:bg-zinc-400 hover:text-black align-content-center">
                          MINT
                      </button>
                  </Link>
              </div>
              : null
          }
          <img className="z-30 mt-2 container" src={banner}/>
         {<div className="flex justify-center mx-auto mt-0 z-50" style={{marginBottom: '-30px'}}>
           <div className="flex-grow-0">
             <div className="text-lg text-center">
               NOW MINTING!
             </div>
               {
                   /*
                    <Countdown
                      className="mt-0"
                      date={new Date('27 May 2022 12:00 PDT')}
                      onMount={({completed}) => completed}
                      onComplete={()=>{}}
                      renderer={renderCounter}
                      status={'status'}
                    />
                */
               }
           </div>
          </div>}
          <div className="flex flex-col">
              <div className="hidden md:block">
                  <div className="flex justify-around items-center">
                      <img className="z-30 mt-2 w-1/4 lg:w-1/2" src={heroOGChefFemale}/>
                      <div className="z-10 absolute object-bottom">{video}</div>
                      <img className="z-30 mb-4 ml-5 w-1/4 lg:w-1/2" src={heroOGChefMale}/>
                  </div>
              </div>
              <div className="md:hidden flex-col">
                  <div className="flex-row relative">
                      <div className="z-10 object-bottom">{video}</div>
                  </div>
                  <div className="flex flex-row">
                      <img className="z-30 w-1/2 mx-auto" src={heroOGChefFemale}/>
                      <img className="z-30 w-1/2 mx-auto" src={heroOGChefMale}/>
                  </div>
              </div>
          </div>
      </div>
  );
}

const renderCounter = ({days, hours, minutes, seconds, completed, props}) => {
  if (completed) {
    return props.status ? <div className="flex-grow-0 text-3xl font-bold">
      <div className="flex justify-end p-4 pt-10 pb-0 align-bottom">{props.status}</div>
    </div>: null;
  } else {
    return (
      <div id="counter-text" className="flex-grow-0 p-2 pb-0 mt-0">
        <div className="flex justify-end p-2 pb-0 mt-0 pt-0" >
          <div className="flex flex-col p-2 m-1 mt-0 rounded bg-gray-500 w-16 text-center">
            <span className="text-3xl font-bold">{hours + (days || 0) * 24}</span>
            <span>hrs</span>
          </div>
          <div className="flex flex-col p-2 m-1 mt-0 rounded bg-gray-500 w-16 text-center">
            <span className="text-3xl font-bold">{minutes}</span>
            <span>min</span>
          </div>
          <div className="flex flex-col p-2 m-1  mt-0 rounded bg-gray-500 w-16 text-center">
            <span className="text-3xl font-bold">{seconds}</span>
            <span>sec</span>
          </div>
        </div>
      </div>
    );
  }
};

export default HeroPanel;

